export interface PromotionalContent {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    contentUrl: string
}

export interface PagedPromotionalContent {
    items: PromotionalContent[]
    totalCount: number
}

export const PROM_CONTENT_FIELD_LABELS: Record<string, string> = {
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    media: "Media",
}
